var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9789 22.489H19.2971V11.9054L21.1715 5.86847L19.8417 5.39565L13.771 22.489H10.2079L4.13298 5.39565L2.80739 5.86847L4.68179 11.9054V22.4933H0V1.25H6.96992L11.2929 13.4083V16.9798H12.7071V13.4083L17.0301 1.25H24V22.489H23.9789Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMode);
export default __webpack_public_path__ + "static/media/mode.fa259aa99a3c191319b301f2747e6ab4.svg";
export { ForwardRef as ReactComponent };